import React, { useState } from "react";
import { SocialLogin } from "./socialLogin";
import { useLogin } from "./useLogin";
import "./styles.scss";
import Box from "schoolUiComponents/basic/Box";
import Button from "schoolUiComponents/basic/Button";
import Text from "schoolUiComponents/basic/Text";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import Input from "schoolUiComponents/basic/Input";
import { Colors } from "baseStyles/enums/colors";
import { FlexProps } from "schoolUiComponents/basic/Box/FlexBox/types";
import { InputTypes } from "schoolUiComponents/basic/Input/types";
import PasswordIcon from "./assets/passwordIcon.svg";
import PasswordShowIcon from "./assets/passwordShowIcon.svg";
import LoginStyles from "./style";
import { interactedLoginViaOtpByClassroomLinkedParentEvent, interactedPtlParentLoginScreenEvent } from "../../ptlSignup/events";

export enum PageNames {
    PTL_LOGIN = "ptlParentLoginScreen",
    PTL_OTP_LOGIN = "loginViaOtpByClassroomLinkedParent",
}

// @ts-ignore
window.ptlLoginEventProps = { pageName: PageNames.PTL_LOGIN, otpEntered: false }

export const FormV2 = ({
    showOTPLoginOption = true,
    primaryInputLabel = "Email",
    showForgotPassword = true,
    showSocialLogin = true,
    source = null,
    sendEvent = (clickedOn: string) => { }
}) => {
    const [passwordVisibility, togglePasswordVisibility] = useState(false);
    const { handleLogin, otpSent, setOTPSent, setIntentId, email, setEmail, error, setError, otpLogin, password, setPassword, timer, sendOTP, otp, setOTP, showResendSuccessMsg, setOTPLogin, socialLoginEnabled, maskedEmail, params, emailEvents, setEmailEvents, passwordEvents, setPasswordEvents, setFromPage, referralData, handleForgotPassword } = useLogin({ primaryInputLabel, showSocialLogin, sendEvent, source, isPtlFlow: true })
    const styles = LoginStyles();

    return (
        <form onSubmit={handleLogin} autoComplete="on" style={{ backgroundColor: Colors.WHITE }}>
            <div className="login-form-v2">
                <FlexBox width={styles.mainBox.width} gap={17} alignStart column>
                    <Box fullWidth>
                        <Input
                            value={email}
                            placeholder={primaryInputLabel}
                            autoFocus={true}
                            tabIndex={1}
                            disabled={otpSent || maskedEmail}
                            onChange={(e) => {
                                if (!(otpSent || maskedEmail)) {
                                    error && setError(null);
                                    setEmail(e.target?.value);
                                    if(!emailEvents.pasted && !emailEvents.typed) {
                                        setEmailEvents({ ...emailEvents, typed: true });
                                        interactedPtlParentLoginScreenEvent({ clickedOn: "Email input box", interactionDetails: "Started typing", ...referralData })
                                    }
                                }
                            }}
                            name="sl-user-login-email"
                            data-test-id="user-login"
                            color={(!email?.length || maskedEmail || otpSent) ? Colors.CONTENT_TEXT_TERTIARY : Colors.DARK_GREY}
                            hasError={error}
                            width={styles.mainBox.width}
                            padding={"16px 24px"}
                            customPlaceholder
                            fontSize={16}
                            lineHeight={24}
                            fontWeight={600}
                            onClick={() => interactedPtlParentLoginScreenEvent({ clickedOn: "Email input box", interactionDetails: "", ...referralData })}
                            onPaste={() => {
                                setEmailEvents({ ...emailEvents, pasted: true });
                                interactedPtlParentLoginScreenEvent({ clickedOn: "Email input box", interactionDetails: "Copy pasted", ...referralData })
                            }}
                        />
                        {
                            (maskedEmail && !params?.user_id) && (
                                <FlexBox justifyContent={FlexProps.JustifyContent.FLEX_END} padding={"0 24px"} fullWidth>
                                    <Box onClick={() => {
                                        if (maskedEmail) {
                                            const searchParams = new URLSearchParams();
                                            Object.keys(params || {}).forEach((key) => searchParams.append(key, params?.[key]));
                                            window.location.href = `/ptl-setup?${searchParams}`;
                                        }
                                        sendEvent(`Change email`);
                                        interactedLoginViaOtpByClassroomLinkedParentEvent({ clickedOn: `Change email`, interactionDetails: "", otpEntered: (otp?.length === 6), ...referralData });
                                    }} ><Text.NORMAL emphasis noUnderline cta>Change email</Text.NORMAL></Box>
                                </FlexBox>
                            )
                        }
                        {otpLogin && !otpSent && error && <Box padding={"0 24px"} fullWidth><Text.SMALL color={Colors.DARK_RED_2} fullWidth lines={3}>{error}</Text.SMALL></Box>}
                    </Box>
                    {!otpLogin &&
                        <Box fullWidth>
                            <Input
                                value={password}
                                type={passwordVisibility ? InputTypes.TEXT : InputTypes.PASSWORD}
                                placeholder={"Password"}
                                tabIndex={2}
                                onChange={(e) => {
                                    error && setError(null);
                                    if(!passwordEvents.pasted && !passwordEvents.typed) {
                                        setPasswordEvents({ ...passwordEvents, typed: true });
                                        interactedPtlParentLoginScreenEvent({ clickedOn: "Password input box", interactionDetails: "Started typing", ...referralData })
                                    }
                                    setPassword(e.target?.value);
                                }}
                                name="sl-user-login-password"
                                data-test-id="user-password"
                                color={!password?.length ? Colors.CONTENT_TEXT_TERTIARY : Colors.DARK_GREY}
                                hasError={error}
                                width={styles.mainBox.width}
                                padding={"16px 24px"}
                                customPlaceholder
                                icon={<FlexBox height={24} onClick={() => togglePasswordVisibility(visible => !visible)}>{passwordVisibility ? <PasswordShowIcon /> : <PasswordIcon />}</FlexBox>}
                                fontSize={16}
                                lineHeight={24}
                                fontWeight={600}
                                onClick={() => interactedPtlParentLoginScreenEvent({ clickedOn: "Password input box", interactionDetails: "", ...referralData })}
                                onPaste={() => {
                                    setPasswordEvents({ ...passwordEvents, pasted: true });
                                    interactedPtlParentLoginScreenEvent({ clickedOn: "Password input box", interactionDetails: "Copy pasted", ...referralData })
                                }}
                            />
                            {
                                showForgotPassword && (
                                    <FlexBox
                                        tabIndex={4}
                                        justifyContent={FlexProps.JustifyContent.FLEX_END} padding={"0 24px"} fullWidth>
                                        <Box onClick={() => {
                                            interactedPtlParentLoginScreenEvent({ clickedOn: "Forgot Password", interactionDetails: "", ...referralData })
                                            handleForgotPassword?.();
                                        }} ><Text.NORMAL emphasis noUnderline cta>Forgot password?</Text.NORMAL></Box>
                                    </FlexBox>
                                )
                            }
                            {error && <Box padding={"0 24px"} fullWidth><Text.SMALL color={Colors.DARK_RED_2} fullWidth lines={3}>{error}</Text.SMALL></Box>}
                        </Box>
                    }
                    {otpLogin && otpSent && (
                        <FlexBox gap={8} fullWidth column alignStart>
                            {otpLogin && otpSent && (
                                <Text.SMALL color={Colors.CONTENT_TEXT_SECONDARY}>
                                    We’ve sent a verification code to the email above.
                                </Text.SMALL>
                            )}
                            <div className="otp-text">
                                <input
                                    type="text"
                                    className="otp"
                                    maxLength={6}
                                    autoComplete="off"
                                    onChange={({ target }) => {
                                        error && setError(null);
                                        setOTP(target?.value);
                                        // @ts-ignore
                                        window.ptlLoginEventProps.otpEntered = (target?.value?.length === 6)
                                    }}
                                    autoFocus={true}
                                    value={otp}
                                    data-test-id="otp-input"
                                    onClick={() => interactedLoginViaOtpByClassroomLinkedParentEvent({ clickedOn: "OTP input", interactionDetails: "", otpEntered: (otp?.length === 6), ...referralData })}
                                />
                                <input className="autocomplete" type="email" readOnly />
                                {["", "", "", "", "", ""].map((char, index) => (
                                    <div className="otp-box">{otp?.[index] || ""}</div>
                                ))}
                            </div>
                            {
                                otpSent && (
                                    <FlexBox className={`${timer ? "disabled otp-timer" : ""}`}
                                        onClick={timer > 0 ? null : () => sendOTP()} justifyContent={FlexProps.JustifyContent.FLEX_END} padding={"0 24px"} fullWidth><Text.NORMAL emphasis opacity={timer > 0 ? 0.4 : 1} noUnderline cta>Resend code {timer ? (
                                            <>
                                                {" "}
                                                in <strong>{timer}s</strong>
                                            </>
                                        ) : (
                                            ""
                                        )}</Text.NORMAL></FlexBox>
                                )
                            }
                            {error && <Box padding={"0 24px"} fullWidth><Text.SMALL color={Colors.DARK_RED_2} fullWidth lines={3}>{error}</Text.SMALL></Box>}
                            {showResendSuccessMsg && (
                                <p className="info success">
                                    <i className="iconcust-iconCheck" /> A new verification code
                                    has been sent.
                                </p>
                            )}
                        </FlexBox>
                    )}
                    <FlexBox gap={16} column fullWidth>
                        <Button
                            primary
                            onClick={handleLogin}
                            data-test-id="login-submit-button"
                            tabIndex={3}
                            disabled={!email?.length}
                        >
                            <Text.H4 color={Colors.WHITE}>{otpLogin ? "Submit" : "Log in"}</Text.H4>
                        </Button>
                        {showOTPLoginOption && (
                            <Button
                                bordered
                                onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    setOTPLogin((value) => !value);
                                    setError(null);
                                    if(otpLogin){
                                        // @ts-ignore
                                        window.ptlLoginEventProps.pageName = PageNames.PTL_OTP_LOGIN;
                                        setFromPage("Parent login via otp verification screen");
                                        interactedLoginViaOtpByClassroomLinkedParentEvent({ clickedOn: "Login with password", interactionDetails: "", otpEntered: (otp?.length === 6), ...referralData });
                                    }
                                    else {
                                        // @ts-ignore
                                        window.ptlLoginEventProps.pageName = PageNames.PTL_LOGIN;
                                        setFromPage("Parent login screen");
                                        interactedPtlParentLoginScreenEvent({ clickedOn: "Log in via verification code", interactionDetails: "", ...referralData });
                                    }
                                }}
                                data-test-id="verification-code-hypertext"
                            >
                                <Text.H4 color={Colors.PURE_PURPLE} hoverColor={Colors.NAVY_BLUE}>Login via {otpLogin ? "password" : "verification code"}</Text.H4>
                            </Button>
                        )}
                    </FlexBox>
                    {otpLogin && otpSent && (
                        <Text.SMALL fullWidth lines={3} color={Colors.CONTENT_TEXT_TERTIARY}>
                            If you are not seeing the email, the email may have landed in your spam folder, or your account may be associated with a different email.
                        </Text.SMALL>
                    )}
                </FlexBox>
                {socialLoginEnabled && (
                    <>
                        <div className="or-bar">
                            <p className="or-bar-text">or Login with</p>
                        </div>
                        <SocialLogin />
                    </>
                )}
            </div>
        </form>
    )
}